import React from 'react';
import {
  Box,
  Backdrop,
  CircularProgress,
  Typography
} from '@mui/material';

interface PDFGenerationLoaderProps {
  open: boolean;
}

const PDFGenerationLoader: React.FC<PDFGenerationLoaderProps> = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(8px)',
      }}
      open={open}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        maxWidth: 400,
        mx: 2,
      }}>
        <CircularProgress 
          size={80} 
          thickness={4}
          sx={{
            color: 'primary.main',
            mb: 3,
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 600, 
            mb: 2,
            color: 'white',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
          }}
        >
          Generating Your Lease Agreement
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'rgba(255,255,255,0.9)',
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          We're creating your California-focused lease draft. Please review all terms and disclosures for accuracy and legal compliance.
        </Typography>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'rgba(255,255,255,0.7)',
          fontSize: '0.875rem',
        }}>
          <Box sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: 'primary.main',
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': {
                opacity: 1,
                transform: 'scale(1)',
              },
              '50%': {
                opacity: 0.5,
                transform: 'scale(1.2)',
              },
              '100%': {
                opacity: 1,
                transform: 'scale(1)',
              },
            },
          }} />
          <span>Processing document...</span>
        </Box>
      </Box>
    </Backdrop>
  );
};

export default PDFGenerationLoader; 
